const parseSprintField = sprintFieldValue => {
    //The sprint field seems to be an array, always containing a single item
    if(Array.isArray(sprintFieldValue)){
        
        let id = 0;
        let current = '';
    
        if(sprintFieldValue) {
            sprintFieldValue.forEach((sprint) => {
                if(sprint.id > id) {
                    id = sprint.id;
                    current = sprint.name;
                }
            });
        }
        return current;
    }
    
    //typename@typeid[key1=value1,key2=,key3=value3]
    const [, commaSeperatedStringKeyValuePairs] = /\[(.*)]/.exec(sprintFieldValue);

    if(!commaSeperatedStringKeyValuePairs){
        return undefined;
    }

    return commaSeperatedStringKeyValuePairs.split(',').reduce((sprint, sprintKeyValuePair) => {
        const [key, value] = sprintKeyValuePair.split('=');
        sprint[key] = value || undefined;

        return sprint;
    }, {});
};

const fieldType = {
    default: 'default',
    custom: 'custom',
    time: 'timetracking',
    comment: 'comment'
};

const fields = {
    summary: {
        type: fieldType.default,
        name: 'summary'
    },
    weight: {
        type: fieldType.custom,
        name: 'customfield_11108'
    },
    requestedBy: {
        type: fieldType.custom,
        name: 'customfield_11107'
    },
    sprint: {
        type: fieldType.custom,
        name: 'customfield_10007',
        parse: parseSprintField 
    },
    remaining: {
        type: fieldType.time,
        name: 'remainingEstimate'
    },
    estimated: {
        type: fieldType.time,
        name: 'originalEstimate'
    },
    priority: {
        type: fieldType.default,
        name: 'priority'
    },
    comment: {
        type: fieldType.comment,
        name: 'comment'
    }
};

const formUpdate = (model) => {
    const update = {};
    const keys = Object.keys(model);

    keys.forEach((key) => {
        const field = fields[key];
        
        if(field) {
            if(field.type === fieldType.time) {
                update.timetracking = update.timetracking || [];
                
                if(update.timetracking.length === 0) {
                    update.timetracking.push({ edit: {} });
                }

                update.timetracking[0].edit[field.name] = model[key];   //"timetracking": [ { "edit": { "remainingestimate": "4h" } } ]

            } else if(field.type === fieldType.comment) {       // "comment": [ { "add": { "body": "<comment>" } } ]
                update[field.name] = [{
                    add: { body: model[key] } 
                }];
            }else {
                update[field.name] = [{
                    set: field.type === fieldType.default ? 
                        model[key] : model[key] !== null ?      // Default field: { "set": "<value>" }
                        { id: model[key].id } :                 // Custom field (by id): { "set": { "id": "<id>" } }
                        null                                    // Remove value: { "set": null }
                }];
            }
        } 
    });

    return update;
};

export default {
    fields,
    fieldType,
    formUpdate
};

export {
    fields,
    fieldType,
    formUpdate
};